<template>
  <div v-for="(locale, i) in locales" :key="`locale-${i}`" :value="locale">
    <div @click="selectLanguage(i)"  :class="this.selected === i ? 'active-language' : ''">
      {{ locale }}
    </div>
  </div>
</template>
  
  <script>
  export default {
    name: "LocaleSwitcher",
    data() {
      return { locales: ["Eesti", "English", "Čeština", "Español"], selected: 0 };
    },
    methods:{
      selectLanguage(key){
	switch (key){
	 case 0:
             this.$i18n.locale = "ee";
             break;
         case 1:
             this.$i18n.locale = "en";
	     break;
	 case 2:
	     this.$i18n.locale = "cs";
	     break;
	 case 3:
	     this.$i18n.locale = "es";
	}
        this.selected = key;
      }
    }
  };
  </script>

<style scoped lang="scss">
.active-language {
  color: #007bff;
}

</style>

  
